import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { Component, Fragment, lazy, Suspense } from 'react';

import ThemeProvider from 'hb-react/style/ThemeProvider';

const FacebookPlugin = lazy(() => import('./FacebookPlugin'));
const TwitterPlugin = lazy(() => import('./TwitterPlugin'));

class SocialPlugin extends Component {
  state = {
    width: 456,
    renderFbWidget: true,
  };

  componentDidMount() {
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  }

  updateWidth = () => {
    if (this.socialPlugin?.offsetWidth > 180) {
      this.setState({ width: this.socialPlugin.offsetWidth });
    }
  };

  socialEnabled = ({ provider }) => {
    const { usersCanAcceptCookiesForWidgets } = this.props;
    const { renderFbWidget } = this.state;

    if (provider === 'facebook' && !renderFbWidget) {
      return false;
    }

    // Always display widgets if the new cookie banner is not activated or used on the network
    if (!usersCanAcceptCookiesForWidgets) {
      return true;
    }

    try {
      const cookiesConsentList = JSON.parse(
        Cookies.get('cookie_consent_list_fo'),
      );
      const cookieNames = { facebook: 'Facebook', twitter: 'Twitter' };

      if (cookiesConsentList !== undefined) {
        const socialCookie = cookiesConsentList.functional.find(
          ({ name }) => name === cookieNames[provider],
        );

        return socialCookie.accepted;
      }

      return false;
    } catch (_e) {
      return false;
    }
  };

  render() {
    const { height, socials } = this.props;
    const { width } = this.state;

    if (window.is_from_china) {
      return null;
    }

    return (
      <div
        className="social-plugin__container deprecated--visuallyhidden--palm"
        ref={(ref) => (this.socialPlugin = ref)}
        data-testid="social-plugin"
      >
        <Suspense fallback={null}>
          {socials
            .filter((social) => this.socialEnabled(social))
            .map((social) => {
              const pluginProps = { social, height };

              return (
                <Fragment key={`${social.provider}-${social.id}`}>
                  {social.provider === 'facebook' ? (
                    <FacebookPlugin {...pluginProps} width={width} />
                  ) : (
                    <ThemeProvider theme="fo">
                      <TwitterPlugin {...pluginProps} />
                    </ThemeProvider>
                  )}
                </Fragment>
              );
            })}
        </Suspense>
      </div>
    );
  }
}

SocialPlugin.propTypes = {
  height: PropTypes.number,
  socials: PropTypes.arrayOf(
    PropTypes.shape({
      provider: PropTypes.string.isRequired,
      pluginType: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
      tabs: PropTypes.string,
    }),
  ),
  usersCanAcceptCookiesForWidgets: PropTypes.bool,
};

SocialPlugin.defaultProps = {
  height: 500,
  socials: [],
  usersCanAcceptCookiesForWidgets: false,
};

export default SocialPlugin;
